'use client';
/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import e from"react";import{motion as t}from"../../node_modules/framer-motion/dist/es/render/dom/motion.js";const o=o=>e.createElement("svg",{viewBox:"0 0 24 24",fill:"none",...o},e.createElement("circle",{cx:12,cy:12,r:12,fill:"#fff",opacity:"0.2"}),e.createElement(t.path,{initial:{pathLength:0},animate:{pathLength:1},transition:{delay:.1,type:"tween",ease:"easeOut",duration:.2},d:"M7 13l3 3 7-7",stroke:"hsl(218, 18%, 42%)",strokeWidth:2,strokeLinecap:"round",strokeLinejoin:"round"}));export{o as default};
//# sourceMappingURL=CheckIcon.js.map
